const Loading: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`animate-spin ${props.className ?? ''}`}>
      <path
        d="M10 0.833a9.167 9.167 0 1 0 9.167 9.167A9.167 9.167 0 0 0 10 0.833m0 15.833a6.667 6.667 0 1 1 6.667 -6.667 6.667 6.667 0 0 1 -6.667 6.667"
        fill="#D9D9D9"
      />
      <path
        d="M10 3.333a6.667 6.667 0 0 1 6.575 5.583 1.275 1.275 0 0 0 1.242 1.083 1.25 1.25 0 0 0 1.233 -1.458 9.167 9.167 0 0 0 -18.1 0A1.25 1.25 0 0 0 2.183 10a1.275 1.275 0 0 0 1.242 -1.083A6.667 6.667 0 0 1 10 3.333"
        fill="currentColor"
      />
    </svg>
  );
};

export default Loading;
